import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { PATHS } from './paths';

export function UnauthorizedPage() {
  return (
    <div className="flex min-h-[55vh] flex-col items-center justify-center text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <ShieldAlert className="size-6" />
      </div>
      <h1 className="mt-4 text-2xl font-semibold">Access denied</h1>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        Your account does not have permission to view this page.
      </p>
      <Link
        to={PATHS.root}
        className="mt-6 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
      >
        Back to start
      </Link>
    </div>
  );
}
